export const optionsSelect = [
    { label: 'Assinatura', value: '0' },
    { label: 'Renovação assinatura', value: '1' },
    { label: 'Consulta', value: '2' },
    { label: 'Estorno positivo', value: '3' },
    { label: 'Recarga avulsa', value: '5' },
    { label: 'Crédito expirado', value: '6' },
  ];